import { render } from "./PaymentsForm.vue?vue&type=template&id=282969aa&scoped=true"
import script from "./PaymentsForm.vue?vue&type=script&lang=js"
export * from "./PaymentsForm.vue?vue&type=script&lang=js"

import "./PaymentsForm.vue?vue&type=style&index=0&id=282969aa&lang=scss&scoped=true"
import "./PaymentsForm.vue?vue&type=style&index=1&id=282969aa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282969aa"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QList from 'quasar/src/components/item/QList.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QAvatar,QBtn,QBanner,QIcon,QSeparator,QList,QInput,QField,QCheckbox,QChip,QToggle,QItemLabel,QExpansionItem,QCard,QCardSection,QSelect,QInnerLoading});
